(function () {
  // Active en mobile uniquement (mais le fichier est chargé partout)
  const mq = window.matchMedia('(max-width: 767px)');
  let overlay = null;
  let isBound = false;

  // ===== Lazy mobile uniquement =====
  function initLazyMobile() {
    const root = document.querySelector('.product-gallery--mobile');
    if (!root) return;
    const nodes = root.querySelectorAll('img[data-src], source[data-srcset]');
    if (!nodes.length) return;

    const upgrade = el => {
      if (el.tagName === 'IMG' && el.dataset.src) {
        el.src = el.dataset.src;
        el.removeAttribute('data-src');
      }
      if (el.tagName === 'SOURCE' && el.dataset.srcset) {
        el.srcset = el.dataset.srcset;
        if (el.dataset.sizes) el.sizes = el.dataset.sizes;
        el.removeAttribute('data-srcset');
        el.removeAttribute('data-sizes');
      }
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries,o)=>{
        entries.forEach(e=>{ if(e.isIntersecting){ upgrade(e.target); o.unobserve(e.target); }});
      }, {rootMargin:'200px 0px', threshold:0.01});
      nodes.forEach(n=>io.observe(n));
    } else {
      const load=()=>nodes.forEach(upgrade);
      ['scroll','resize','orientationchange'].forEach(ev=>addEventListener(ev,load));
      load();
    }
  }

  // ===== Gestes =====
  function enableGestures(img, track) {
    let scale = 1, startDist = 0, lastTap = 0;
    let offsetX = 0, offsetY = 0, startX = 0, startY = 0;

    const clamp = (v,min,max)=>Math.max(min,Math.min(max,v));
    const dist = (t)=>Math.hypot(t[0].clientX-t[1].clientX, t[0].clientY-t[1].clientY);
    const getCenter = (t)=>({ x:(t[0].clientX+t[1].clientX)/2, y:(t[0].clientY+t[1].clientY)/2 });

    function applyTransform() {
      const maxX = (scale-1)*window.innerWidth/2;
      const maxY = (scale-1)*window.innerHeight/2;
      offsetX = clamp(offsetX, -maxX, maxX);
      offsetY = clamp(offsetY, -maxY, maxY);
      img.style.transform = `translate(${offsetX}px,${offsetY}px) scale(${scale})`;
      if (track) track.style.overflowX = scale > 1 ? 'hidden' : 'auto';
    }

    function onStart(e){
      if(e.touches && e.touches.length===2){ startDist = dist(e.touches); }
      if(e.touches && e.touches.length===1 && scale>1){
        startX = e.touches[0].clientX - offsetX;
        startY = e.touches[0].clientY - offsetY;
      }
    }

    function onMove(e){
      if(e.touches && e.touches.length===2){
        e.preventDefault();
        const newDist = dist(e.touches);
        const center = getCenter(e.touches);
        img.style.transformOrigin = `${center.x}px ${center.y}px`;
        scale = clamp(scale*(newDist/startDist),1,3);
        applyTransform();
      }
      if(e.touches && e.touches.length===1 && scale>1){
        e.preventDefault();
        offsetX = e.touches[0].clientX - startX;
        offsetY = e.touches[0].clientY - startY;
        applyTransform();
      }
    }

    function onEnd(e){
      if(scale<1.05){ scale=1; offsetX=0; offsetY=0; }
      applyTransform();

      const now=Date.now();
      if(now-lastTap<300){
        e.preventDefault();
        const touch=(e.changedTouches && e.changedTouches[0]) || { clientX: window.innerWidth/2, clientY: window.innerHeight/2 };
        img.style.transformOrigin = `${touch.clientX}px ${touch.clientY}px`;
        if(scale>1){ scale=1; offsetX=0; offsetY=0; } else { scale=2; offsetX=0; offsetY=0; }
        applyTransform();
      }
      lastTap=now;
    }

    img.addEventListener('touchstart', onStart, { passive:false });
    img.addEventListener('touchmove', onMove, { passive:false });
    img.addEventListener('touchend', onEnd, { passive:true });

    img.resetZoom = () => {
      scale=1; offsetX=0; offsetY=0;
      img.style.transform='scale(1)';
      if (track) track.style.overflowX = 'auto';
    };
  }

  // ===== Overlay =====
  function closeOverlay(){
    if(!overlay) return;
    overlay.querySelectorAll('img').forEach(im => { if(im.resetZoom) im.resetZoom(); });
    overlay.remove();
    overlay=null;
    document.body.style.overflow='';
  }

  function openOverlay(startIndex,triggers){
    if(overlay) return;
    overlay=document.createElement('div');
    overlay.className='custom-zoom-overlay';

    const closeBtn=document.createElement('div');
    closeBtn.className='custom-zoom-close';
    closeBtn.textContent='×';

    const track=document.createElement('div');
    track.className='custom-zoom-track';
    track.style.overflowX = 'auto';
    track.style.webkitOverflowScrolling = 'touch';

    triggers.forEach((el,idx)=>{
      const slide=document.createElement('div');
      slide.className='custom-zoom-slide';

      const srcHD=el.dataset.full || el.getAttribute('data-full') || el.dataset.src || el.getAttribute('data-src');
      const imgEl=el.querySelector('img');
      const im=new Image();
      im.alt=imgEl?.alt||'';
      im.src = imgEl?.currentSrc || imgEl?.src || '';

      if (idx===startIndex) {
        im.src=srcHD; im.loading='eager'; im.fetchPriority='high';
      } else {
        im.dataset.src = srcHD;
        im.loading='lazy';
      }

      im.style.touchAction = 'auto';
      enableGestures(im, track);
      slide.appendChild(im);
      track.appendChild(slide);
    });

    overlay.append(closeBtn,track);
    document.body.appendChild(overlay);
    document.body.style.overflow='hidden';
    requestAnimationFrame(()=>{ track.scrollLeft=startIndex*track.clientWidth; });

    function lazyLoadAt(index){
      const cur = track.children[index]?.querySelector('img[data-src]');
      if (cur) { cur.src = cur.dataset.src; cur.removeAttribute('data-src'); }
      const next = track.children[index+1]?.querySelector('img[data-src]');
      if (next) { next.src = next.dataset.src; next.removeAttribute('data-src'); }
    }
    lazyLoadAt(startIndex);
    track.addEventListener('scroll', ()=>{
      const idx=Math.round(track.scrollLeft/track.clientWidth);
      lazyLoadAt(idx);
    }, { passive:true });

    closeBtn.addEventListener('click',closeOverlay,{passive:true});
    overlay.addEventListener('click',e=>{
      if(!e.target.closest('img') && !e.target.closest('.custom-zoom-close')) closeOverlay();
    },{passive:true});
  }

  // ===== Bind mobile (sans toucher au desktop) =====
  function bindMobile() {
    if (isBound) return;
    const mobileRoot = document.querySelector('.product-gallery--mobile');
    if (!mobileRoot) return;

    // lazy + swiper
    initLazyMobile();
    document.querySelectorAll('.js-slider[data-config="product-gallery-slider"]').forEach(el => {
      el.dispatchEvent(new CustomEvent('slider:enable', { bubbles: true }));
    });
    if (window.initSliders) { try { window.initSliders(); } catch(e){} }

    // délégation fiable (swiper ne casse pas)
    const onClick = (e) => {
      const t = e.target.closest('.product-gallery--mobile .js-lightgallery-trigger');
      if (!t) return;
      e.preventDefault();
      const triggers=[...mobileRoot.querySelectorAll('.js-lightgallery-trigger')];
      triggers.forEach((a,i)=>{ if(!a.dataset.idx) a.dataset.idx=i; });
      const idx = parseInt(t.dataset.idx || '0', 10);
      openOverlay(isNaN(idx)?0:idx, triggers);
    };
    mobileRoot.addEventListener('click', onClick, true);

    // mémorise pour ne pas rebinder
    mobileRoot.__zoomOnClick = onClick;
    isBound = true;
  }

  function unbindMobile() {
    if (!isBound) return;
    const mobileRoot = document.querySelector('.product-gallery--mobile');
    if (mobileRoot && mobileRoot.__zoomOnClick) {
      mobileRoot.removeEventListener('click', mobileRoot.__zoomOnClick, true);
      delete mobileRoot.__zoomOnClick;
    }
    closeOverlay();
    isBound = false;
  }

  function applyMode(){
    if (mq.matches) bindMobile(); else unbindMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMode);
  } else {
    applyMode();
  }
  if (mq.addEventListener) mq.addEventListener('change', applyMode);
  else mq.addListener(applyMode);
})();
